<div class="logo-trademark">
    <img src="assets/images/trinity-logo.svg" alt="trinity-logo">
    <span class="txt">Trinity, All Rights Reserved © {{currentYear}}</span>
</div>
